<app-layout>
  <div class="collaborators-acceptance">
    <h1>Convite!</h1>
    <section>
      <p>Parabéns!</p>
      <p>Você foi convidado para ser um colaborador de um evento</p>
    </section>
    <app-button (btnClick)="acceptInvitation()" [style]="'max-width:400px;'" icon="pi pi-check" [disabled]="loading">
      Aceitar convite
    </app-button>
  </div>
</app-layout>
